import { useState } from "react";
import { Brand } from "@/components/Layout";

export function useLang() {
  const init = new URLSearchParams(window.location.search).get("lang") || localStorage.getItem("pub-lang") || ((navigator.language || "it").startsWith("it") ? "it" : "en");
  const [lang, setLang] = useState(init === "en" ? "en" : "it");
  const set = (l) => { localStorage.setItem("pub-lang", l); setLang(l); };
  return [lang, set, (it, en) => (lang === "en" ? en : it)];
}

const LangSwitch = ({ lang, setLang }) => (
  <div className="absolute top-4 right-4 flex bg-white/90 rounded-full p-0.5 text-xs" data-testid="lang-switch">
    {[["it", "🇮🇹 IT"], ["en", "🇬🇧 EN"]].map(([k, l]) => <button key={k} onClick={() => setLang(k)} className={`px-2.5 py-1 rounded-full ${lang === k ? "bg-[#0D2B3A] text-white" : ""}`} data-testid={`lang-${k}`}>{l}</button>)}
  </div>
);

export const PublicShell = ({ children, testId, lang, setLang, hero }) => (
  <div className="min-h-screen bg-gradient-to-b from-[#EAF5F7] via-[#F5FAFB] to-white" data-testid={testId}>
    <div className={`relative overflow-hidden ${hero ? "h-[430px] sm:h-[480px]" : "h-56 sm:h-72"}`}>
      <img src={hero ? "/img/mare.jpg" : "/img/mare1.jpg"} alt="" className={`w-full h-full object-cover ${hero ? "scale-105 animate-[kenburns_18s_ease-in-out_infinite_alternate]" : ""}`} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D2B3A]/40 to-[#0D2B3A]/80" />
      <div className="absolute top-4 left-4 bg-white/90 rounded-full px-3 py-1.5"><Brand small /></div>
      {setLang && <LangSwitch lang={lang} setLang={setLang} />}
      {hero && <div className="absolute inset-x-0 top-20 sm:top-24 px-5 text-center text-white max-w-2xl mx-auto">{hero}</div>}
    </div>
    <main className={`max-w-xl mx-auto px-4 relative pb-16 fade-up ${hero ? "-mt-20 sm:-mt-24" : "-mt-24 sm:-mt-32"}`}>{children}</main>
  </div>
);

export const Card = ({ children }) => <div className="rounded-2xl bg-white shadow-xl border border-[#D4E6EC] p-6 sm:p-8 space-y-4">{children}</div>;

export function Stars({ value, onChange, testId }) {
  return (
    <div className="flex gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => <button key={n} type="button" onClick={() => onChange(n)} className={`text-3xl leading-none transition-transform hover:scale-110 ${n <= (value || 0) ? "text-[#E3B04B]" : "text-[#D4E6EC]"}`} data-testid={`${testId}-${n}`} aria-label={`${n} stelle`}>★</button>)}
    </div>
  );
}
